import React, { useEffect } from "react";
import CustomLoader from "components/base/loader";
import Login from "./Login";

export default function MicrosoftRedirect() {

  useEffect(() => {
    const { origin, search } = window.location;
    
    const isMicrosoftOAuth = () => {
      const urlParams = new URLSearchParams(search);
      
      const hasMicrosoftParams = 
        urlParams.has('code') || 
        urlParams.has('state') || 
        urlParams.has('session_state') ||
        urlParams.has('error');
      
      return hasMicrosoftParams;
    };
    
    if (isMicrosoftOAuth()) {
      window.location.replace(`${origin}/signin/microsoft${search}`);
    } else {
      window.location.replace(origin);
    }
  }, []);

  return (
    <Login />
  );
}

